import { formFieldRule } from '../formFieldRuleEnum';
export const formFieldRuleOperators = Object.freeze([
	{
		Id: formFieldRule.Accepted,
		Title: 'accepted',
		Subtitle: 'The form is valid when the field is yes, no or 1',
	},
	{
		Id: formFieldRule.AfterD,
		Title: 'after:D',
		Subtitle:
			'Provided a date, the field value must also be a date later than D',
	},
	{
		Id: formFieldRule.Alpha,
		Title: 'alpha ',
		Subtitle: 'Only letters allowed',
	},
	{
		Id: formFieldRule.AlphaDash,
		Title: 'alpha_dash',
		Subtitle: 'Only letters and _ (underscore) allowed',
	},
	{
		Id: formFieldRule.AlphaNum,
		Title: 'alpha_num',
		Subtitle: 'Only letters and numbers allowed',
	},
	{
		Id: formFieldRule.BeforeD,
		Title: 'before:D ',
		Subtitle: 'When providing a date, the date value must earlier than D',
	},
	{
		Id: formFieldRule.BetweenXY,
		Title: 'between:X,Y',
		Subtitle:
			'If the field is int (see Type), the number must be between X and Y (i.e. 2<11). Otherwise, a string comparison is performed (i.e. 2 > 11)',
	},
	{
		Id: formFieldRule.ConfirmedFAndSameF,
		Title: 'confirmed:F and same:F',
		Subtitle: 'The value should be the same as the one in the F field',
	},
	{
		Id: formFieldRule.DifferentF,
		Title: 'different:F',
		Subtitle: 'The value must be different than the one in the F field',
	},
	{
		Id: formFieldRule.Date,
		Title: 'date',
		Subtitle: 'The value must be a valid date',
	},
	{
		Id: formFieldRule.In,
		Title: 'in:a,b,c,...',
		Subtitle: 'The value must be one of the provided values in a,b,c,...',
	},
	{
		Id: formFieldRule.IntegerAndNumeric,
		Title: 'integer and numeric',
		Subtitle: 'The value must only consist of numbers',
	},
	{
		Id: formFieldRule.Ip,
		Title: 'ip',
		Subtitle: 'The value must be a valid IP address (e.g. 255.255.255.255)',
	},
	{
		Id: formFieldRule.MaxX,
		Title: 'max:X ',
		Subtitle:
			"If the field type is int, the value must not be greater than X. If it's varchar the length of the string should not be greater than X",
	},
	{
		Id: formFieldRule.MinX,
		Title: 'min:X ',
		Subtitle:
			"If the field type is int, the value must not be lower than X. If it's varchar, the length of the string should not be lower than X",
	},
	{
		Id: formFieldRule.NotIn,
		Title: 'not_in:a,b,c,...',
		Subtitle: 'The value cannot be any of the provided values in a,b,c,...',
	},
	{
		Id: formFieldRule.Regex,
		Title: 'regex:.*',
		Subtitle:
			'The value must match the regular expression provided. The expression must be valid inboth  PHP and JavaScript',
	},
	{
		Id: formFieldRule.RequiredIf,
		Title: 'required_if:F,V',
		Subtitle:
			'Tested field becomes required if the other field F has the value V. Unlike Laravel, this only works with one other field, though multiple required_if can be provided for the same effect.',
	},
	{
		Id: formFieldRule.RequiredWith,
		Title: 'required_with:F1,F2,..',
		Subtitle:
			'The field becomes required if any of the provided fields is not empty',
	},
	{
		Id: formFieldRule.RequiredWithout,
		Title: 'required_without:F1,F2,..',
		Subtitle: 'required_without_all:F1,F2,...',
	},
	{
		Id: formFieldRule.Size,
		Title: 'size:X',
		Subtitle:
			'With varchar fields (see Type), the length of the string must be exactly X',
	},
	{
		Id: formFieldRule.Url,
		Title: 'url',
		Subtitle:
			'Field must be a valid URL having explicitly listing http,https, ftp or ftps as the protocol',
	},
	{
		Id: formFieldRule.MaxOne,
		Title: '(server-side validation only) max_one',
		Subtitle:
			'Use this rule so that the field it is attached has to be unique in the database',
	},
	{
		Id: formFieldRule.MaxOneIf,
		Title: '(server-side validation only) max_one_if:F,V1,V2...',
		Subtitle:
			'Same as max_one, but is only enforced when field F has the one of the Vx values',
	},
	{
		Id: formFieldRule.MaxOneUnless,
		Title: '(server-side validation only) max_one_unless:F,V1,V2...',
		Subtitle:
			' same as max_one, but will not be enforced when field F has the one of the Vx values',
	},
]);
